module.exports = __webpack_public_path__ + "img/pakistan-logo-icon.4163c575.png";